import {
  Component,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  LeafletMapComponent
} from 'src/app/leaflet-map/leaflet-map.component';
import {
  Station
} from 'src/app/models/api_models/station';
import {
  PublicService
} from 'src/app/api/public.service';
import { AutorizationService } from 'src/app/api/autorization.service';
import { PageConfigService } from 'src/app/page-config.service';
import { PageConfig } from 'src/app/models/display/pageConfig';
import { ViewportScroller } from '@angular/common';


@Component({
  selector: 'app-basic-page',
  templateUrl: './basic-page.component.html',
  styleUrls: ['./basic-page.component.scss']
})
export class BasicPageComponent implements OnInit {

  @ViewChild('leafletMap') leafletMapChild: LeafletMapComponent;

  private _currentGps: [number, number] = [.6311634, 3.0599573];
  get currentGps() {
    return this._currentGps;
  }
  set currentGps(currentGps) {
    this._currentGps = currentGps;
  }

  private _mapStationSelected: Station;
  get mapStationSelected(): Station {
    return this._mapStationSelected;
  }
  set mapStationSelected(mapStationSelected) {
    this._mapStationSelected = mapStationSelected;
  }



  // Stations autopartages envoyées sur le block leaflet et la selection des station du formulaire 
  private _stationList: Station[] = [];
  get stationList() {
    return this._stationList;
  }
  set stationList(stationList) {
    this._stationList = stationList;
  }

  private _stationSelected: Station = null;
  get stationSelected() {
    return this._stationSelected;
  }
  set stationSelected(stationSelected) {
    this._stationSelected = stationSelected;
  }


  stationChangedHandler(stationFocus: Station) {
    // conslog(stationFocus);
    this._currentGps = [stationFocus.latitude, stationFocus.longitude];
    this._mapStationSelected = stationFocus;
  }
  pageConfig: PageConfig = null;
  constructor(private viewportScroller: ViewportScroller, private publicApiService: PublicService, private pageConfigService: PageConfigService, private autorizationService: AutorizationService) {}





   
//   public onClick(elementId: string): void { 
//     this.pageConfigService.onClick(elementId);
//     this.viewportScroller.scrollToAnchor(elementId);
// }












  ApiInit() {

    if(location.pathname === "/velo"){
      var service = 10
    }else{
      var service = 0
    }

    this.publicApiService.getStationList(service).subscribe(
      reponse => {
        this._stationList = reponse;
        if (this._stationList.length > 0) {
          this._stationSelected = this._stationList[0];
        }
        // conslog(this.stationList);

      }
    );
  }

  public isLoad = false;
  private getService() {
    this.pageConfig = null;
    this.autorizationService.login(null).subscribe(
      reponse => {
        // conslog("login");

        this.pageConfigService.getConfig(this.pageConfigService.defaultConfig).subscribe(
          reponse => {
            //            this.pageConfig = <PageContent>reponse;
            // conslog("this.pageConfig");
            this.pageConfig = < PageConfig > reponse;
            // conslog(this.pageConfig.servicesList);

            this.isLoad = true;
          },
          error => {
            this.pageConfigService.getConfig(this.pageConfigService.defaultConfig).subscribe(
              reponse => {
                this.pageConfig = < PageConfig > reponse;
              }
            )
          }
        )
      }
    )
  }

  // elementId

  // scrol(){
  //   this.pageConfigService.onClick(this.elementId);
  //   this.viewportScroller.scrollToAnchor(this.elementId);
    
  // }

  
  ngOnInit() {
    this.stationList = [];
    this.ApiInit();
    this.getService();
  
  }


}
